import React, {useState} from 'react'
import {useLoaderData, useNavigate} from "react-router";
import {Form} from "../../ui/elements/form";
import {Field} from "../../ui/elements/field";
import {EnvelopeIcon, UserCircleIcon} from "@heroicons/react/24/solid";
import {Button} from "../../ui/elements/button";
import * as API from '@/api'
import {useAuth} from "../../../contexts/auth_context";
import {useToast} from "../../ui/toast";

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export const UserManagerScreen = props => {
  const { user, setUser } = useAuth()
  const { credentials: creds } = useLoaderData()
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState(creds)
  const {toast} = useToast()


  const onSubmit = async (evt) => {
    const formData = new FormData(evt.target);

    API.Users.update(user, formData).
      then(() => {
      toast({message: 'Saved'})
    });
  }

  const signOut = () => {
    API.My.Session.destroy().then(() => {
      setUser(null)
      navigate("/", {state: {toast: {message: 'Signed out'}}})
    });
  }

  const addPasskey = async () => {
    await API.My.User.webauthn_initiate().then(async cred => {
      navigator.credentials.create({
        publicKey: {
          challenge: Uint8Array.from(Array.from(cred.challenge).map(letter => letter.charCodeAt(0))),
          rp: { id: window.location.host.replace(/\:\d+/, ''), name: "Cushvlog" },
          user: {
            id: new Uint8Array([cred.user.id]),
            displayName: cred.user.username,
            name: cred.user.email
          },
          pubKeyCredParams: [{ type: "public-key", alg: -7 }],
        }
      }).then(c => {
        result = {
          id: c.id,
          rawId: arrayBufferToBase64(c.rawId),
          response: {
            clientDataJSON: arrayBufferToBase64(c.response.clientDataJSON),
            authenticatorData: arrayBufferToBase64(c.response.getAuthenticatorData()),
            transports: c.response.getTransports(),
            publicKey: arrayBufferToBase64(c.response.getPublicKey()),
            publicKeyAlgorithm: c.response.getPublicKeyAlgorithm(),
            attestationObject: arrayBufferToBase64(c.response.attestationObject)
          },
          authenticatorAttachment: "platform",
          clientExtensionResults: c.getClientExtensionResults(),
          type: "public-key",
        };

        API.My.User.webauthn_finalize(result).then(setCredentials)
      })
    })
  }

  const removeCredential = async (cred) => {
    if (!confirm('Are you sure you want to delete this passkey?')) return;

    API.My.Credentials.destroy(cred).then(() => {
      const newCredentials = [...credentials];
      newCredentials.splice(newCredentials.indexOf(cred), 1);
      setCredentials(newCredentials);
    })
  }

  return <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <h2 className="text-4xl font-[Axiforma_Black]">{user ? 'User' : 'Sign Up'}</h2>
      </div>

      <Form onSubmit={onSubmit}>
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-[Axiforma_Black]">Profile</h2>
            <div className="flex flex-col gap-1">
              <Field name="username" autoCapitalize="off" spellCheck={false} type="text" icon={UserCircleIcon}
                     placeholder="Username" value={user?.username}/>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-[Axiforma_Black]">Contact</h2>
            <div className="flex flex-col gap-1">
              <Field name="email" autoCapitalize="off" spellCheck={false} type="text" icon={EnvelopeIcon}
                     placeholder="Email" value={user?.email} note="This will be used to send you a login code."/>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div>
              <h2 className="text-2xl font-[Axiforma_Black]">Notifications</h2>
              <div className="text-sm">Get notified when a replay is about to start.</div>
            </div>
            <div className="flex flex-col gap-4 mt-4">
              <div className="flex flex-col gap-0.5">
                <Field type="checkbox" name="notify_by_email" checked={user?.notify_by_email} label="Email"/>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4 w-full">
            <Button className="w-full" type="submit">Save</Button>
            {user && <Button variant="danger" className="w-full" type="button" onClick={signOut}>Sign Out</Button>}
          </div>
        </div>
      </Form>
    </div>
}